import { updateLinksAttributes } from '../../utils/handleAttributes';

export default function customSignup() {
  const widgetName = 'customSignup';
  const widgetOpts = customSignupOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      const emailSignup = $('.content .emailSignup');
      $widget.replaceWith(emailSignup);

      if (hasData) {
        createCustomSignUp(data.items);
      } else {
        $widget.remove();
        emailSignup.remove();
      }
    },
  });

  function createCustomSignUp(widgetData) {
    updateSignupFeature(widgetData, widgetName);
  }
}

function updateSignupFeature(data, idName) {
  const { Title: signupTitle, Description: signupText, URL: signupURL } = data[0];
  const containerSectionClass = 'video-signup-container';
  const inputPlaceholder = 'Email Address';
  const buttonLabel = 'Subscribe';

  const $signupElement = $(`.${containerSectionClass} .emailSignup`);
  const $signupText = $signupElement.find('.emailSignupText');

  $signupText.replaceWith(`
    <div class="signup-text">
      <div class="signup-heading">
          <span class="signup-icon"></span>
          <h3 class="signup-title">${signupTitle}</h3>
      </div>
      ${signupText ? `<p class="signup-description">${signupText}</p>` : ''}
    </div>
    `);

  $signupElement.attr('id', idName);
  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-container"></div>');
  $signupElement.find('.emailInputField input').val('').attr('placeholder', inputPlaceholder);
  $signupElement.find('.emailInputSubmit a').text(buttonLabel);

  if (signupURL == null || signupURL === '') {
    return;
  } else {
    $signupElement.find('.input-container').addClass('custom-signup').empty().append(`
      <a href="${signupURL}" class="button" ${updateLinksAttributes(signupURL, signupText)}>${buttonLabel}</a>`);
  }
}
